//Auth state constants
export const UPDATE_THRIV_AUTH = 'update_thriv_auth'
export const UPDATE_VERIFY_DOB = 'UPDATE_VERIFY_DOB'

export const initialThrivAuthState: ThrivAuthState = {
  email: '',
  redirectTo: '',
  showVerifyDOBPopup: false,
}
